import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import { Swipeable } from 'react-swipeable';
import Text from 'components/shared/Text';
import dummyData from '../dummyData';
import { CircularProgress } from '@material-ui/core';
import EmptyCard from '../../EmptyCard';

const MobileVisual = ({
  userPackagesData,
  userPackagesMessage,
  isPackagesLoading
}) => {
  const totalCards = userPackagesData?.length;
  const [position, setPosition] = useState(0);

  const handleSwipe = direction => {
    if (direction === 'left' && position < totalCards - 1) {
      setPosition(position + 1);
    } else if (direction === 'right' && position > 0) {
      setPosition(position - 1);
    }
  };

  const carouselWidth = totalCards * (151 + 30);

  return (
    <div className={`${styles.child} ${isPackagesLoading ? styles.loading : null}`}>
      {userPackagesData === null ? (
        <div>
          {!isPackagesLoading ? (
            <EmptyCard message={userPackagesMessage} />
          ) : (
            <CircularProgress size={50} style={{ color: '#FE5000', marginTop: '50px' }} />
          )}
        </div>
      ) : (
        <>
          {!isPackagesLoading ? (
            <Swipeable
              onSwipedLeft={() => handleSwipe('left')}
              onSwipedRight={() => handleSwipe('right')}
            >
              <div
                className={`${styles.carouselContainer} ${
                  totalCards === 1 || 2 ? styles.adjustWidth : null
                }`}
              >
                <div
                  className={styles.carousel}
                  style={{
                    transform: `translateX(${-position * (151 + 30)}px)`,
                    width: `${carouselWidth}px`,
                  }}
                >
                  {userPackagesData?.map((data, index) => {
                    return (
                      <div key={index} className={styles.card}>
                        <div className={styles.cardSubContainer1}>
                          <Text className={styles.cardHeading}>{data.name}</Text>
                          <Text className={styles.cardSubHeading}>{data.quantity}</Text>
                        </div>
                        <div className={styles.cardSubContainer2}>
                          <div className={styles.circle}>{data.remainingCount}</div>
                          <Text className={styles.cardContent}>Remaining</Text>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Swipeable>
          ) : (
            <CircularProgress
              size={50}
              style={{
                color: '#FE5000',
                marginTop: '50px',
              }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default MobileVisual;
